let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3jm7G")).then(() => parcelRequire('1WvJN'));